/* Klaviyo sinup fomr linstner */
window.addEventListener("klaviyoForms", function (e) {
  if (e.detail != null) {
    if (e.detail.type == "stepSubmit") {
      setTimeout(() => {
        $(`.klaviyo-form-${e.detail.formId}`).addClass("klaviyo-stepSubmit");
      }, 300);
    }
    if (e.detail.type == "embedOpen") {
      if ($(".body-collection-2023").length > 0) {
        setTimeout(() => {
          embedOpen(e.detail.formId);
        }, 2000);
      }
    }
  }
});
function embedOpen(formId) {
  var _attr = "data-count-" + formId;
  var _lang = $(`.klaviyo-form-${formId}`).parent().attr("data-lang") || null;
  var _form = $(`.klaviyo-form-${formId}`);
  if (_form.closest("footer").length > 0) return;
  var _selector = $(
    _form.find(
      'input[type="radio"][name*="Language"][aria-label="' +
        _lang +
        '"]:not(:checked)+label'
    )
  );
  //console.log('_selector',formId,_selector, _selector.length, _attr);
  if (_selector == null || _selector.length == 0) {
    if ($("body[" + _attr + "]").length == 0) {
      $("body").attr(_attr, "0");
    }
    var _count = Number($("body").attr(_attr));
    if (_count < 25) {
      setTimeout(() => {
        _count = _count + 1;
        $("body").attr(_attr, _count);
        embedOpen(formId);
      }, 500);
    }
  }
  if (_selector.length != 0 && _lang != null) {
    $("body").removeAttr(_attr);
    _selector.trigger("click");
  }

  return;
}
$(window).on("load", function (e) {
  if ($(".body-collection-2023").length > 0 && $("html").attr("lang") != null) {
    setTimeout(() => {
      $(
        '[name*="Language"][aria-label="' +
          $("html").attr("lang") +
          '"]:not(:checked)+label'
      ).trigger("click");
    }, 1000);
  }
});
/* Klaviyo sinup fomr linstner */
//Product new tampltae JS -- START
var _setTimoeout = 1;

$(window).on("resize", function (e) {
  mainSlider();
  if ($(".pro-accessories-slider.slick-initialized").length > 0) {
    $(".pro-accessories-slider.slick-initialized").slick("unslick");
    _setTimoeout += 100;
  }
  logoslider();
});

$(window).on("scroll", function () {
  var scrollTop = $(this).scrollTop();
  if ($(window).width() > 749) {
    var height_header =
      $(".announcement-bar").outerHeight() +
      $(".header-main-block").outerHeight();
    if ($(".template-page.body-collection-2023").length > 0) {
      height_header = $(".header-main-block").outerHeight();
    }
    var attrib_type = "data-url-type";
  } else {
    var height_header = $(".header-main-block").outerHeight();
    var attrib_type = "data-url-type-mobile";
  }

  scrollTop >= height_header
    ? $("body").addClass("headerscrolled")
    : $("body").removeClass("headerscrolled");
  var atcBtn = 0;
  if ($(".coll-landing-img-text").length > 0) {
    atcBtn = $(".coll-landing-img-text").offset().top - height_header;
  }

  scrollTop >= atcBtn
    ? ($(".unlock-vip-access-wrapper").addClass("active"),
      $("body").addClass("unlock-vip-access-active"))
    : ($(".unlock-vip-access-wrapper").removeClass("active"),
      $("body").removeClass("unlock-vip-access-active"));
  scrollTop >= atcBtn &&
  $(window).width() < 641 &&
  $(".unlock-vip-access-wrapper").length > 0
    ? $("body").css(
        "padding-bottom",
        $(".unlock-vip-access-wrapper").outerHeight(true) + "px"
      )
    : $("body").css("padding-bottom", "");
  $(window).width() > 640
    ? scrollTop >= atcBtn
      ? $(".unlock-vip-access-wrapper").css({ top: height_header })
      : $(".unlock-vip-access-wrapper").css({ top: 0 })
    : $(".unlock-vip-access-wrapper").css({ top: "" });

  // var videoplay = $('.video-section').offset().top - height_header - $('.unlock-vip-access-wrapper').outerHeight() - 25;
  var videoplay = 0;
  if ($(".video-section").length > 0) {
    if ($(".unlock-vip-access-wrapper").length > 0) {
      videoplay =
        $(".video-section").offset().top -
        height_header -
        ($(window).width() > 749
          ? $(".unlock-vip-access-wrapper").outerHeight()
          : 0);
    } else {
      videoplay = $(".video-section").offset().top - height_header - 0;
    }
  }
  var videoplayOffsetHeight = videoplay + $(".video-section").outerHeight(true);

  if (
    $(".video-section .video-section-wrapper").attr(attrib_type) == "youtube"
  ) {
    if ($("body[self-click]").length == 0) {
      $("body").trigger("click");
      $("body").click();
      var _src = $("body")[0];
      var event = (event = new Event("click", {
        bubbles: true,
        composed: true,
      }));
      _src.dispatchEvent(event);
      $("body").attr("self-click", "");
    }
    if (scrollTop >= videoplay && scrollTop <= videoplayOffsetHeight) {
      if (!$(".video-section").hasClass("playactive")) {
        $(".video-section .hidden-buttons #play-button").trigger("click");
        $(".video-section").addClass("playactive");
      }
    } else {
      $(".video-section .hidden-buttons #pause-button").trigger("click");
      $(".video-section").removeClass("playactive");
    }
  } else if (
    $(".video-section .video-section-wrapper").attr(attrib_type) == "vimeo"
  ) {
    if ($("body[self-click]").length == 0) {
      $("body").trigger("click");
      $("body").click();
      $("body").attr("self-click", "");
    }
    if (scrollTop >= videoplay && scrollTop <= videoplayOffsetHeight) {
      if (
        !$(".video-section").hasClass("playactive") &&
        typeof Vimeo != "undefined" &&
        $(".iframe_Desk-false iframe").length > 0
      ) {
        player = new Vimeo.Player($(".iframe_Desk-false iframe")[0]);
        player.play();
        $(".video-section").addClass("playactive");
      }
    } else {
      if (
        typeof Vimeo != "undefined" &&
        $(".iframe_Desk-false iframe").length > 0
      ) {
        player = new Vimeo.Player($(".iframe_Desk-false iframe")[0]);
        player.pause();
        $(".video-section").removeClass("playactive");
      }
    }
  } else if (
    $(".video-section .video-section-wrapper").attr(attrib_type) == "mp4"
  ) {
    if ($("body[self-click]").length == 0) {
      $("body").trigger("click");
      $("body").click();
      var _src = $("body")[0];
      var event = (event = new Event("click", {
        bubbles: true,
        composed: true,
      }));
      _src.dispatchEvent(event);
      $("body").attr("self-click", "");
    }
    if (scrollTop >= videoplay && scrollTop <= videoplayOffsetHeight) {
      if (!$(".video-section").hasClass("playactive")) {
        if ($(window).width() > 749) {
          var slide_play = $("#video_player")[0];
        } else {
          var slide_play = $("#video_player_mobile")[0];
        }
        if (slide_play) {
          slide_play.muted = true;
          slide_play.play();
          setTimeout(() => {
            slide_play.muted = false;
          }, 250);
        }
        $(".video-section").addClass("playactive");
      }
    } else {
      if ($(window).width() > 749) {
        var slide_play = $("#video_player")[0];
      } else {
        var slide_play = $("#video_player_mobile")[0];
      }
      if (slide_play) {
        slide_play.muted = true;
        slide_play.pause();
      }
      $(".video-section").removeClass("playactive");
    }
  }
});

function logoslider() {
  if ($(window).width() > 749) {
    $(".marquee-logo-new .marquee-logo-wrap")
      .not(".slick-initialized")
      .slick({
        speed: 5000,
        autoplay: true,
        autoplaySpeed: 100,
        cssEase: "linear",
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        buttons: false,
        swipe: false,
        draggable: false,
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 1251,
            settings: {
              slidesToShow: 4,
            },
          },
        ],
      });
  }
  if ($(window).width() < 750) {
    $(".marquee-logo-new .marquee-logo-wrap-mb")
      .not(".slick-initialized")
      .slick({
        speed: 5000,
        autoplay: true,
        autoplaySpeed: 100,
        cssEase: "linear",
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        buttons: false,
        swipe: false,
        draggable: false,
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 641,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });
  }
}

/*-- Code change 5/11 start --*/
function slickClass() {
  var _visibleSlider = $(".pro-accessories-slider:visible");

  if (
    _visibleSlider.length > 0 &&
    _visibleSlider.hasClass("slick-initialized")
  ) {
    var _slidesToShow = _visibleSlider.slick("slickGetOption", "slidesToShow");

    if (_visibleSlider.find(".gridproductwrapper").length - _slidesToShow > 0) {
      _visibleSlider.removeClass("noSlickSlide");
    } else {
      _visibleSlider.addClass("noSlickSlide");
    }

    _visibleSlider.on(
      "afterChange",
      function (event, slick, currentSlide, nextSlide) {
        var _lastSlider = slick.$slides[slick.$slides.length - 1];

        if ($(_lastSlider).hasClass("slick-active")) {
          slick.$slider.addClass("lastSlideSlide");
        } else {
          slick.$slider.removeClass("lastSlideSlide");
        }
      }
    );

    return true;
  } else {
    //console.error('Slick slider not initialized or visible.');
    return false;
  }
}
/*-- Code change 5/11 end --*/

function drawerAccessoriesSlider() {
  if ($(window).width() < 768) {
    $(
      ".pro-accessories-slider.sliderVertical_true.slick-initialized:visible"
    ).slick("unslick");
    $(
      ".cartDrawer .pro-accessories-slider.sliderVertical_true:visible"
    ).addClass("slick-slider no-SSlider");
    return;
  } else {
    $(".pro-accessories-slider.sliderVertical_true:visible").slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      vertical: true,
      arrows: true,
      variableWidth: false,
      verticalSwiping: true,
      adaptiveHeight: false,
      draggable: true,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            vertical: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            adaptiveHeight: false,
          },
        },
      ],
    });

    $(".pro-accessories-slider.sliderVertical_true:visible").on(
      "afterChange",
      function (event, slick, currentSlide) {
        if ($(window).width() > 767) {
          var _height = 0,
            _Slickheight = $(slick.$slider).height(),
            _slideToShow = 0,
            _height2 = 0;
          var accessoriesHeight =
            $(".drawer__accessories").outerHeight() -
            $(".drawer__accessories .pro-accessories h3").outerHeight(true) -
            40;

          for (var i = 0; i < slick.$slides.length; i++) {
            _height = _height + $(slick.$slides[i]).height();
            if (i > currentSlide - 1) {
              _height2 = _height2 + $(slick.$slides[i]).height();
            }
          }
          var _transform = $(slick.$slideTrack).css("transform");
          _transform = Number(
            _transform
              .split(",")
              [_transform.split(",").length - 1].replace(/\D/g, "")
          );
          var diffrence = accessoriesHeight - _height2;
          if (diffrence >= 0) {
            var diffrence =
              $(slick.$list).offset().top +
              $(slick.$list).height() -
              ($(slick.$slideTrack).offset().top +
                $(slick.$slideTrack).height());

            _transform =
              diffrence < 0
                ? _transform + Math.abs(diffrence)
                : _transform - diffrence;

            $(slick.$slider).find(".slick-next").addClass("slick-disabled");
            $(slick.$slider).find(".slick-next").attr("aria-disabled", "true");
            setTimeout(function () {
              $(slick.$slider).addClass("lastSlideSlide");
              $(slick.$slideTrack).css(
                "transform",
                "translate3d(0px, -" + _transform + "px, 0px)"
              );
            }, 250);
          } else {
            $(slick.$slider).removeClass("lastSlideSlide");
          }
        }
      }
    );
  }
  return false;
}

function mainSlider() {
  //console.log("mainSlider()");
  if ($(".shopify-section:not(.main-product) .main__slider").length > 0) {
    //console.log("if inside not main slider");
    if (
      $(".main__slider.slick-initialized").length > 0 &&
      $(".thumb__slider.slick-initialized").length > 0
    )
      return;
    if (
      $(".thumb__slider.slick-initialized").length > 0 &&
      $(window).width() > 767
    )
      return;
    setTimeout(function () {
      $(".main__slider:not(.slick-initialized)").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        nextArrow:
          '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="38" viewBox="0 0 21 38" fill="none"><path d="M1.67773 1L19.3554 18.6777L1.67773 36.3553" stroke="#C9C1B9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        prevArrow:
          '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="38" viewBox="0 0 20 38" fill="none"><path d="M18.6777 36.3555L1.00006 18.6778L18.6777 1.00013" stroke="#C9C1B9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        fade: true,
        dots: false,
        asNavFor: ".thumb__slider",
        swipeToSlide: true,
        swipe: true,
        speed: 500,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              speed: 500,
              touchThreshold: 20,
            },
          },
        ],
      });
    }, _setTimoeout);
    var _setTimoeoutTem = _setTimoeout + 250;
    var slideToShowCustomDk = 4;
    var slideToShowCustomMb = 5;
    if (
      $("body").hasClass("body-new-v2") &&
      $(".product-main-slider .thumbnails-customer").length > 0
    ) {
      slideToShowCustomDk = 3;
      slideToShowCustomMb = 4;
    }
    setTimeout(function () {
      $(".thumb__slider:not(.slick-initialized)").slick({
        slidesToShow: slideToShowCustomDk,
        slidesToScroll: 1,
        arrows: true,
        asNavFor: ".main__slider",
        dots: false,
        focusOnSelect: true,
        swipeToSlide: true,
        swipe: true,
        speed: 500,
        touchThreshold: 20,
        responsive: [
          {
            breakpoint: 750,
            settings: {
              speed: 500,
              slidesToShow: slideToShowCustomMb,
              touchThreshold: 20,
              //centerMode: true,
              arrows: false,
              //centerPadding: '0px'
            },
          },
        ],
      });

      if ($(".thumb__slider.slick-initialized")[0].slick.slideCount > 5) {
        $(".thumbnails-wrapper").addClass("sliderScrolling");
      } else {
        $(".thumbnails-wrapper").removeClass("sliderScrolling");
      }

      /*-- Code change 5/11 start --*/
      function handleThumbSliderScroll() {
        var $thumbSlider = $("body .thumb__slider.enableScrolling");

        if ($(window).width() < 768) {
          $thumbSlider.unbind("scroll");

          $thumbSlider.bind(
            "scroll",
            theme.Helpers.debounce(function (e) {
              var _scrollWidth = $(this)[0].scrollWidth - $(this).width() - 10;
              var _scrollLeft = $(this).scrollLeft();
              var _parent = $(this).closest(".thumsWrapperImg");

              if (_scrollLeft < 10) {
                $(_parent).addClass("left");
              } else {
                $(_parent).removeClass("left");
              }

              if (_scrollLeft >= _scrollWidth) {
                $(_parent).addClass("right");
              } else {
                $(_parent).removeClass("right");
              }

              var _index = null;
              var _childLength = $(this).find(
                ".product-single__thumbnails-item"
              );
            }, 250)
          );
        } else {
          $thumbSlider.removeClass("enableScrolling");
          $thumbSlider.unbind("scroll");
        }
      }

      // Call handleThumbSliderScroll when the document is ready and on window resize
      $(document).ready(function () {
        handleThumbSliderScroll();
      });

      $(window).resize(function () {
        handleThumbSliderScroll();
      });
      /*-- Code change 5/11 end --*/
    }, _setTimoeoutTem);
    return false;
  }

  // PDP template ===============> products--SS23

  if ($(".main-product .main__slider").length > 0) {
    //console.log("if inside main slider");

    $(".main__slider").on("init", function (event, slick) {
      event.preventDefault();
      setTimeout(function () {
        $(".main__slider.slick-initialized").css("opacity", 1);
        $(".thumb__slider.slick-initialized").css("opacity", 1);
        $("[data-pro-def-img]").css("opacity", 0);
        // mainPro_reInitMediaVideos(2000);
      }, 1000);
    });

    const slider = $(".main__slider:not(.slick-initialized)").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: true,
      asNavFor: ".thumb__slider",
      vertical: true,
      verticalSwiping: true,
      speed: 700,
      /*fade:true,
        cssEase: "linear",*/
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            vertical: false,
            verticalSwiping: false,
            swipeToSlide: true,
            swipe: true,
            arrows: true,
            prevArrow:
              '<button class="slick-prev slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="12" viewBox="0 0 17 12" fill="none"><path d="M5.64256 -9.92899e-07L5.24537e-07 6L5.64256 12L8.3915 12L4.79859 8.352C4.36454 7.92 3.80993 7.368 3.35178 6.936C4.38866 6.96 4.84681 6.96 5.32908 6.96L17 6.96L17 5.04L5.32908 5.04C4.84681 5.04 4.36454 5.04 3.35178 5.064C3.80993 4.632 4.36454 4.152 4.77447 3.72L8.3915 -7.52579e-07L5.64256 -9.92899e-07Z" fill="#2B2A60"/></svg></button>',
            nextArrow:
              '<button class="slick-next slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="12" viewBox="0 0 17 12" fill="none"><path d="M11.3574 12L17 6L11.3574 0L8.6085 0L12.2014 3.648C12.6355 4.08 13.1901 4.632 13.6482 5.064C12.6113 5.04 12.1532 5.04 11.6709 5.04L0 5.04L0 6.96L11.6709 6.96C12.1532 6.96 12.6355 6.96 13.6482 6.936C13.1901 7.368 12.6355 7.848 12.2255 8.28L8.6085 12H11.3574Z" fill="#2B2A60"/></svg></button>',
          },
        },
        {
          breakpoint: 750,
          settings: {
            vertical: false,
            verticalSwiping: false,
            swipeToSlide: true,
            swipe: true,
            arrows: true,
            prevArrow:
              '<button class="slick-prev slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="12" viewBox="0 0 17 12" fill="none"><path d="M5.64256 -9.92899e-07L5.24537e-07 6L5.64256 12L8.3915 12L4.79859 8.352C4.36454 7.92 3.80993 7.368 3.35178 6.936C4.38866 6.96 4.84681 6.96 5.32908 6.96L17 6.96L17 5.04L5.32908 5.04C4.84681 5.04 4.36454 5.04 3.35178 5.064C3.80993 4.632 4.36454 4.152 4.77447 3.72L8.3915 -7.52579e-07L5.64256 -9.92899e-07Z" fill="#2B2A60"/></svg></button>',
            nextArrow:
              '<button class="slick-next slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="12" viewBox="0 0 17 12" fill="none"><path d="M11.3574 12L17 6L11.3574 0L8.6085 0L12.2014 3.648C12.6355 4.08 13.1901 4.632 13.6482 5.064C12.6113 5.04 12.1532 5.04 11.6709 5.04L0 5.04L0 6.96L11.6709 6.96C12.1532 6.96 12.6355 6.96 13.6482 6.936C13.1901 7.368 12.6355 7.848 12.2255 8.28L8.6085 12H11.3574Z" fill="#2B2A60"/></svg></button>',
          },
        },
      ],
    });

    // use x and y mousewheel event data to navigate flickity
    function slick_handle_wheel_event(e, slick_instance, slick_is_animating) {
      // do not trigger a slide change if another is being animated
      if (!slick_is_animating) {
        // pick the larger of the two delta magnitudes (x or y) to determine nav direction
        var direction =
          Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;

        //console.log("wheel scroll ", e.deltaX, e.deltaY, direction);

        if (direction > 0) {
          // next slide
          slick_instance.slick("slickNext");
        } else {
          // prev slide
          slick_instance.slick("slickPrev");
        }
      }
    }
    var slick_2_is_animating = false;
    // debounce the wheel event handling since trackpads can have a lot of inertia
    var slick_handle_wheel_event_debounced = theme.Helpers.debounce(
      slick_handle_wheel_event,
      100,
      true
    );

    slider.on("afterChange", function (event) {
      slick_2_is_animating = false;
      setTimeout(() => {
        slider.removeClass("sliderOnWheel");
      }, 50);
      if (
        $(event.target)
          .find(".slick-active.slick-current")
          .hasClass("media_contains-jpeg")
      ) {
        $(".product-main-slider").addClass("lifestyle-img");
      } else {
        $(".product-main-slider").removeClass("lifestyle-img");
      }
    });

    slider.on("beforeChange", function (event) {
      slider.addClass("sliderOnWheel");
      slick_2_is_animating = true;
    });

    if ($(window).width() > 750) {
      slider.on("wheel", function (e) {
        e.preventDefault();
        slick_handle_wheel_event_debounced(
          e.originalEvent,
          slider,
          slick_2_is_animating
        );
        if (slider.hasClass("sliderOnWheel")) return;
        slider.addClass("sliderOnWheel");
        // if (e.originalEvent.deltaY < 0) {
        //   $(this).slick('slickPrev');
        // } else {
        //   $(this).slick('slickNext');
        // }
      });
    }

    $(".thumb__slider:not(.slick-initialized)").slick({
      slidesToShow: 9,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      asNavFor: ".main__slider",
      dots: false,
      focusOnSelect: true,
      speed: 550,
      vertical: true,
      verticalSwiping: true,
      responsive: [
        {
          breakpoint: 1551,
          settings: {
            slidesToShow: 6,
          },
        },
        {
          breakpoint: 750,
          settings: {
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipeToSlide: false,
            arrows: false,
            dots: true,
            vertical: false,
          },
        },
      ],
    });
    // return false;
    mainPro_reInitMediaVideos(3000);
  }
  // END END END ---> PDP template ===============> products--SS23
}

function proAccessoriesSlider(type) {
  setTimeout(function () {
    if (
      $(".pro-accessories-slider.slick-initialized:not(.sliderVertical_true)")
        .length == 0
    ) {
      $(".pro-accessories-slider:not(.sliderVertical_true)").slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });
    }

    if (type == "load") {
      drawerAccessoriesSlider();
    }

    setTimeout(function () {
      slickClass();
    }, _setTimoeout);
  }, _setTimoeout);
  return false;
}

$(document).on(
  "click",
  ".enableScrolling .product-single__thumbnails-item",
  function () {
    var _index = Number($(this).attr("data-index"));
    if ($(this).addClass("active").hasClass("active")) {
      $(this).siblings(".active").removeClass("active");
      $(this).addClass("active");
    }
    $(".MS_pro.slick-initialized").slick("slickGoTo", _index);
  }
);
$(".main__slider.MS_pro").on(
  "afterChange",
  function (event, slick, currentSlide, nextSlide) {
    $(
      ".thumsWrapperImg .single__thumbnails .product-single__thumbnails-item.active"
    ).removeClass("active");
    $(
      '.thumsWrapperImg .single__thumbnails .product-single__thumbnails-item[data-index="' +
        currentSlide +
        '"]'
    ).addClass("active");
  }
);

$(document).on("click", ".tabWarper .tab", function () {
  var _id = $(this).attr("data-id");
  $(this).siblings(".active").removeClass("active");
  $(_id).siblings(".active").removeClass("active");
  $(_id).addClass("active");
  $(this).addClass("active");
});

/* autoply Video (image-text-new) */
$(".videoTag").each(function (index, ele) {
  var _videoTag = $(this)[0];
  if (_videoTag.paused) {
  } else {
  }
  _videoTag.addEventListener("playing", function () {
    $(_videoTag).closest(".videoParent").addClass("videoLoaded videoLoadedTag");
  });
});

document.addEventListener("DOMContentLoaded", (event) => {
  var extranalVideos =
    document.querySelectorAll('.videoParent div[id*="externalVideo-"]') || [];
  if (extranalVideos.length > 0) {
    for (var i = 0; i < extranalVideos.length; i++) {
      var ID = $(extranalVideos[i]).attr("data-section-id");
      var _sectionID = "shopify-section-" + ID;
      var _section = document.querySelector("#" + _sectionID);
      window[_sectionID] = {};
      var videoContainer = document.getElementById("externalVideo-" + ID);
      var player;
      let playerApi = "";
      let mobilePlayerApi = "";
      let options = "";
      if (typeof videoContainer != "undefined" && videoContainer != null) {
        options = JSON.parse(
          videoContainer.getAttribute("data-section-settings")
        );
        //console.log('options--',options);
        if (options["videoType"] === "youtube") {
          playerApi = "//www.youtube.com/iframe_api";
        } else {
          playerApi = "//player.vimeo.com/api/player.js";
        }
        options.playerApi = playerApi;
        if (options["mobileVideoType"] != undefined) {
          if (options["mobileVideoType"] === "youtube") {
            mobilePlayerApi = "//www.youtube.com/iframe_api";
          } else {
            mobilePlayerApi = "//player.vimeo.com/api/player.js";
          }
          options.mobilePlayerApi = mobilePlayerApi;
        }
        if ($(window).width() > 749) {
          vLoadScript(false, options).then(
            vSetupPlayer(false, options, _section)
          );
        } else {
          if (options.mobilePlayerApi == undefined) {
            vLoadScript(false, options).then(
              vSetupPlayer(false, options, _section)
            );
          } else {
            vLoadScript(true, options).then(
              vSetupPlayer(true, options, _section)
            );
          }
        }
      }
    }
  }
});

function vLoadScript(mobile = false, options) {
  return new Promise(function (resolve, reject) {
    if (options["videoType"] === "youtube" && window.YT != undefined) return;
    if (options["videoType"] === "vimeo" && window.Vimeo != undefined) return;
    // var _reFalse = noToRun(mobile);
    // if( !_reFalse && _reFalse != undefined ) return;
    //if( options.mobilePlayerApi != undefined && mobile && options.mobilePlayerApi == options.playerApi ) return;
    //console.log('asd',options, mobile);
    var script = document.createElement("script");
    document.body.appendChild(script);
    script.onload = resolve;
    script.onerror = reject;
    script.async = true;
    script.src = mobile ? options.mobilePlayerApi : options.playerApi;
  });
}

function vSetupPlayer(mobile = false, options, _section) {
  var ID = $(_section).find("[id*=externalVideo-]").attr("data-section-id");
  _reFalse = noToRun(mobile, _section);
  if (!_reFalse && _reFalse != undefined) return;
  let elementToInsert = _section.querySelector(
    `#${mobile ? "mobile" : ""}External__VideoHolder-${ID}`
  );
  var playerLoadingInterval = setInterval(function () {
    if (options[mobile ? "mobileVideoType" : "videoType"] === "youtube") {
      if (window.YT) {
        //console.log('YT');
        /*var temp = JSON.parse(JSON.stringify(window.YT)); window[_sectionID].YT = temp; console.log( window[_sectionID] );*/
        window.YT.ready(function () {
          player = new YT.Player(elementToInsert, {
            videoId: options[mobile ? "mobileVideoId" : "videoId"],
            playerVars: {
              showinfo: 0,
              controls: 0,
              fs: 0,
              rel: 0,
              height: "100%",
              width: "100%",
              iv_load_policy: 3,
              html5: 1,
              loop: 1,
              mute: 1,
              playlist: options[mobile ? "mobileVideoId" : "videoId"],
              playsinline: 1,
              modestbranding: 1,
              disablekb: 1,
              origin: options["requestHost"],
            },
            events: {
              onReady: onYouTubeReady,
              onStateChange: onYouTubeStateChange,
            },
          });
        });
        clearInterval(playerLoadingInterval);
      }
    } else {
      if (window.Vimeo) {
        /*var temp = JSON.parse(JSON.stringify(window.Vimeo)); window[_sectionID].Vimeo = temp; console.log( window[_sectionID] );*/
        player = new Vimeo.Player(elementToInsert.parentNode, {
          //id: options[mobile ? 'mobileVideoId':'videoId'],
          url: `https://player.vimeo.com/video/${
            options[mobile ? "mobileVideoId" : "videoId"]
          }`,
          autoplay: true,
          muted: mobile ? true : true,
          background: false,
          loop: true,
          controls: true,
        });

        $(player.element).trigger("click");
        player
          .play()
          .then(function () {
            // The video is playing
            $(elementToInsert.parentNode)
              .closest(".videoParent")
              .addClass("videoLoaded");
            $(player.element).find("iframe").addClass("video--image_with_play");
          })
          .catch(function (error) {
            switch (error.name) {
              case "PasswordError":
                // The video is password-protected
                break;
              case "PrivacyError":
                // The video is private
                break;
              default:
                // Some other error occurred
                break;
            }
          });
        // console.log(player,'player');
        player.on("play", function () {
          $(elementToInsert.parentNode)
            .closest(".videoParent")
            .addClass("videoLoaded");
          $(player.element).find("iframe").addClass("video--image_with_play");
          if ($(window).width() > 767) {
            setTimeout(() => {
              //player.setVolume(1);
            }, 250);
          }
          $(elementToInsert.parentNode)
            .closest(".videoParent")
            .addClass("videoLoaded");
          // console.log('Played the video');
        });

        player.getVideoTitle().then(function (title) {
          //console.log('title:', title);
          //player.play()
        });

        clearInterval(playerLoadingInterval);
      }
    }
  }, 50);
}

function onYouTubeReady(event) {
  // event.target.mute();
  var playButton = document.getElementById("play-button");
  playButton.addEventListener("click", function () {
    player.playVideo();
  });

  var pauseButton = document.getElementById("pause-button");
  pauseButton.addEventListener("click", function () {
    player.pauseVideo();
  });
  // event.target.playVideo();
}

function onYouTubeStateChange(event) {
  if (event.data === YT.PlayerState.PLAYING) {
    if (event.target.h != null) {
      event.target.h.closest(".videoParent").classList.add("videoLoaded");
    }
  }
  if (event.target.data === YT.PlayerState.ENDED) {
    //event.target.playVideo();
  }
}

function noToRun(mobile = false, _section) {
  var skipDeskIframe =
    $(_section).find("[id*=externalVideo-]").attr("data-mp4").split(",")[0] ==
    "true";
  var skipMobileIframe =
    $(_section).find("[id*=externalVideo-]").attr("data-mp4").split(",")[1] ==
    "true";
  var hasMobileDiv =
    $(_section).find("[id*=externalVideo-] .mobileExternal__VideoHolder")
      .length > 0;
  if (!skipDeskIframe && !skipMobileIframe) {
    // console.log(mobile);
    if ($(window).width() > 749 && mobile) return false;
    if ($(window).width() < 750 && !mobile) {
      if ($(window).width() < 750 && !mobile && !hasMobileDiv) {
        return true;
      } else {
        return false;
      }
    }
  }
  if (!skipDeskIframe && skipMobileIframe) {
    if ($(window).width() < 750) return false;
  }
  if (skipDeskIframe && !skipMobileIframe) {
    if ($(window).width() > 749) return false;
  }
}
/* autoply Video (image-text-new) */

$(function () {
  mainSlider();
  proAccessoriesSlider("load");

  logoslider();

  $(document).on("click", ".sold-notify-modal .modal-close", function () {
    $(this).closest(".sold-notify-modal").removeClass("model-open");
  });
  $(document).on("click", ".open-block", function (e) {
    e.preventDefault();
    $(".sold-notify-modal").addClass("model-open");
  });

  //For Popup
  $(document).on(
    "click",
    ".design-product .design-product-more .custom-btn , .design-product .design-product-more-v2",
    function (e) {
      e.preventDefault();
      $(".design-popup").addClass("open");
    }
  );
  $(document).on("click", ".design-popup .close-btn", function (e) {
    e.preventDefault();
    $(".design-popup").removeClass("open");

    var url = new URL(window.location.href);
    url.searchParams.delete("redirecturl");
    history.pushState(null, document.title, url);
  });
  $("body").on("click", function (e) {
    if ($(e.target).is(".design-popup.open") === true) {
      $(".design-popup").removeClass("open");
      var url = new URL(window.location.href);
      url.searchParams.delete("redirecturl");
      history.pushState(null, document.title, url);
    }
  });

  var locationurl = window.location.search;
  if (locationurl == "?redirecturl") {
    $(".custom-btn").trigger("click");
  }

  /* product borad position */
  if ($(window).width() < 750 && $(".design-product-col.active").index() >= 5) {
    var _index = $(".design-product-col.active").index();
    $(".design-product-col").each(function (index, element) {
      if (index >= 4 && index < _index) {
        $(element).hide();
      }
    });
    $(".design-product-col.active").css("display", "inherit");
  }
  /* product borad position &*/

  /*Product accessories acordian only*/
  $("#Accordion .accessories-accordian").on("click", function (e) {
    e.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $(".pro-perf-acces .pro-acces-col").offset().top - 65,
      },
      550
    );
  });
  /*END*/

  /*Add to cart sticky*/
  $(window).scroll(
    theme.Helpers.debounce(function (event) {
      var _scrollTop = $(this).scrollTop();
      if (
        $("body.template-product").length &&
        $(".stikey-add-to-cart").length
      ) {
        var aTCBtn = $(".product-form__item--submit").offset().top - 15;
        var aTCBtnTop = $(
          "#shopify-section-header [data-header-section]"
        ).outerHeight(true);
        if ($(window).width() < 768) {
          aTCBtnTop =
            $("#shopify-section-header [data-header-section] .announcement-bar")
              .length > 0
              ? aTCBtnTop -
                $(
                  "#shopify-section-header [data-header-section] .announcement-bar"
                ).outerHeight(true)
              : aTCBtnTop;
        }
        $(".stikey-add-to-cart").css("bottom", 0 + "px");
        //console.log('scrollTop',_scrollTop, 'aTCBtn--',aTCBtn);
        if (_scrollTop >= aTCBtn) {
          $(".stikey-add-to-cart").addClass("open");
          $("body").addClass("sticky-active");
        } else {
          $(".stikey-add-to-cart").removeClass("open");
          $("body").removeClass("sticky-active");
        }
      }
      /* Header annocument bar collepase */
      var _headerSelector = $('[data-section-id="header"] header.site-header');
      if (_headerSelector.length > 0) {
        var _annoumentHeight =
          $("#shopify-section-header .announcement-bar").outerHeight() || 0;
        //console.log(_scrollTop, _annoumentHeight);
        if (
          _scrollTop > _annoumentHeight &&
          $("#shopify-section-header").offset().top > _annoumentHeight &&
          !$("#shopify-section-header").hasClass("headerScroll")
        ) {
          _headerSelector.addClass("headerScroll");
          if (_annoumentHeight > 0 && $(window).width() < 768) {
            if ($(".template-page.body-collection-2023").length == 0) {
              _headerSelector.css(
                "transform",
                "translateY(-" + _annoumentHeight + "px)"
              );
            }
          }
        } else {
          if (_headerSelector.hasClass("headerScroll")) {
            setTimeout(() => {
              _headerSelector.removeClass("headerScroll");
            }, 500);
            _headerSelector.css("transform", "");
          }
        }
      }
      /* Header annocument bar collepase */
    }, 150)
  );

  //add to cart click -- triger main add to cart btn
  $(".stikey-add-to-cart .stikey-add-cart").on("click", function (e) {
    e.preventDefault();
    $(this).addClass("adding");
    $(this).find(".loading-overlay__spinner").removeClass("hidden");
    $(".product-single [data-add-to-cart]").trigger("click");
  });
  //end

  /*END- add to cart sticky*/

  //apply dynamic width to customer thumbnail slide
  if ($(".product-main-slider .thumbnails-customer").length > 0) {
    $(".body-new-v2 .thumb__slider").on("init", function (event, slick) {
      let intialSlickSlideWidth = slick.slideWidth;
      //console.log('slickSlideWidth',intialSlickSlideWidth);
      $(".product-main-slider .thumbnails-customer").css(
        "width",
        intialSlickSlideWidth
      );
      $(".product-main-slider .single__thumbnails__wrap.has-hifestyle-img").css(
        "width",
        "calc(100% - " + intialSlickSlideWidth + "px)"
      );
    });
    $(".body-new-v2 .thumb__slider").on("setPosition", function (event, slick) {
      setTimeout(function () {
        let updateSlickSlideWidth = slick.slideWidth;
        $(".product-main-slider .thumbnails-customer").css(
          "width",
          updateSlickSlideWidth
        );
        $(
          ".product-main-slider .single__thumbnails__wrap.has-hifestyle-img"
        ).css("width", "calc(100% - " + updateSlickSlideWidth + "px)");
      }, 90);
    });
    $(".product-main-slider .thumbnails-customer").on("click", function () {
      var LIFESTYLE_ALT_TEXT = "L1";
      let imgIndex = $(
        '.single__thumbnails__wrap.has-hifestyle-img .product-single__thumbnails-item img[data-lifstyle-alt="' +
          LIFESTYLE_ALT_TEXT +
          '"]'
      )
        .closest(".product-single__thumbnails-item")
        .attr("data-index");
      //console.log('imgIndex',imgIndex);
      if (imgIndex != null) {
        $(".thumb__slider").slick("slickGoTo", Number(imgIndex));
      }
    });
  }
  //END

  if ($(window).width() > 767) {
    $(".coll-landing-review-slider").slick({
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  $(document).on("click", ".collection-landing-form .first-step", function () {
    var temp_val = $(this)
      .closest(".klaviyo_field_group")
      .find("input")
      .val().length;
    if (temp_val > 3) {
      // $(this).closest('.klaviyo_field_group').addClass('hide');
      //$(this).closest('form').find('.second-step').closest('.klaviyo_field_group').removeClass('hide');
      $(this)
        .closest("form")
        .find(".klaviyo_form_actions button")
        .trigger("click");
    } else {
      $(this)
        .closest("form")
        .find(".klaviyo_form_actions button")
        .trigger("click");
    }
  });

  $(document).on(
    "click",
    ".coll-landing-img-text-form .first-step",
    function () {
      var temp_val2 = $(this)
        .closest(".klaviyo_field_group")
        .find("input")
        .val().length;
      if (temp_val2 > 3) {
        //$(this).closest('.klaviyo_field_group').addClass('hide');
        //$(this).closest('form').find('.second-step').closest('.klaviyo_field_group').removeClass('hide');
        $(this)
          .closest("form")
          .find(".klaviyo_form_actions button")
          .trigger("click");
      } else {
        $(this)
          .closest("form")
          .find(".klaviyo_form_actions button")
          .trigger("click");
      }
    }
  );

  $(document).on(
    "click",
    ".collection-landing-text-overlay .first-step",
    function () {
      var temp_val3 = $(this)
        .closest(".klaviyo_field_group")
        .find("input")
        .val().length;
      if (temp_val3 > 3) {
        // $(this).closest('.klaviyo_field_group').addClass('hide');
        // $(this).closest('form').find('.second-step').closest('.klaviyo_field_group').removeClass('hide');
        $(this)
          .closest("form")
          .find(".klaviyo_form_actions button")
          .trigger("click");
      } else {
        $(this)
          .closest("form")
          .find(".klaviyo_form_actions button")
          .trigger("click");
      }
    }
  );

  $(document).on(
    "click",
    ".unlock-vip-access-wrapper .first-step",
    function () {
      var temp_val4 = $(this)
        .closest(".klaviyo_field_group")
        .find("input")
        .val().length;
      if (temp_val4 > 3) {
        // $(this).closest('.klaviyo_field_group').addClass('hide');
        $(this)
          .closest("form")
          .find(".klaviyo_form_actions button")
          .trigger("click");
      } else {
        $(this)
          .closest("form")
          .find(".klaviyo_form_actions button")
          .trigger("click");
      }
    }
  );

  $(document).on("click", ".collection-landing-form .second-step", function () {
    $(this)
      .closest("form")
      .find(".klaviyo_form_actions button")
      .trigger("click");
  });

  $(document).on(
    "click",
    ".coll-landing-img-text-form .second-step",
    function () {
      $(this)
        .closest("form")
        .find(".klaviyo_form_actions button")
        .trigger("click");
    }
  );

  $(document).on(
    "click",
    ".collection-landing-text-overlay .second-step",
    function () {
      $(this)
        .closest("form")
        .find(".klaviyo_form_actions button")
        .trigger("click");
    }
  );

  $(document).on(
    "click",
    ".unlock-vip-access-wrapper .second-step",
    function () {
      $(this)
        .closest("form")
        .find(".klaviyo_form_actions button")
        .trigger("click");
    }
  );

  featuredProductsCarousel();
  improvedMaddleSectionSlide();
});

var pscrollCount = null;
var pscroll = null;
var prevDeltaY = 0;
var blocked = false;
function featuredProductsCarousel() {
  if (!$("[data-products-carousel-grid]").length) {
    return;
  }
  $("[data-products-carousel-grid]").each(function () {
    if ($(this).find(".products-carousel-grid-card").length == 1) {
      $(this).addClass("onlyOneItem");
    }
  });
  $("[data-products-carousel-grid]")
    .not(".slick-initialized")
    .slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      slide: ".products-carousel-grid-card",
      touchMove: true,
      touchThreshold: 500,
      prevArrow: `<button class="slickPrev slick-arrow" aria-label="Previous" type="button">
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
                    <rect x="50" y="50" width="50" height="50" rx="25" transform="rotate(-180 50 50)" fill="#FCFCFB"></rect>
                    <path d="M21.6383 18.5L15 25L21.6383 31.5L24.8723 31.5L20.6454 27.548C20.1348 27.08 19.4823 26.482 18.9433 26.014C20.1631 26.04 20.7021 26.04 21.2695 26.04L35 26.04L35 23.96L21.2695 23.96C20.7021 23.96 20.1348 23.96 18.9433 23.986C19.4823 23.518 20.1348 22.998 20.617 22.53L24.8723 18.5L21.6383 18.5Z" fill="#FF0000"></path>
                  </svg>
                </button>`,
      nextArrow: `<button class="slickNext slick-arrow" aria-label="Next" type="button">
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
                    <rect width="50" height="50" rx="25" fill="#FCFCFB"/>
                    <path d="M28.3617 31.5L35 25L28.3617 18.5H25.1277L29.3546 22.452C29.8652 22.92 30.5177 23.518 31.0567 23.986C29.8369 23.96 29.2979 23.96 28.7305 23.96H15V26.04H28.7305C29.2979 26.04 29.8652 26.04 31.0567 26.014C30.5177 26.482 29.8652 27.002 29.383 27.47L25.1277 31.5H28.3617Z" fill="#FF0000"/>
                  </svg>
                </button>`,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            variableWidth: true,
          },
        },
      ],
    });

  /* Slide on wheel and two finger swipe 
  $('[data-products-carousel-grid].slick-initialized').on('mousewheel DOMMouseScroll wheel', function(e) {
    if( $(window).width() < 992 ){ return; }
    _this = $(this);
    var deltaY = e.originalEvent.deltaY;
    e.preventDefault();
    e.stopPropagation();
    clearTimeout(pscroll);
    pscroll = setTimeout(function(){
      blocked = false;
    }, 50);
    
    if (deltaY > 0 && deltaY > prevDeltaY || deltaY < 0 && deltaY < prevDeltaY || !blocked) {            
      prevDeltaY = deltaY;
      if (deltaY > 0) {
          _this.slick('slickNext');
          blocked = true;
      }
      if (deltaY < 0) {
          _this.slick('slickPrev');
          blocked = true;
      }
    }
  });*/

  /*$('[data-products-carousel-grid].slick-initialized').each(function(index,ele){
    var _prevArrow = $($(ele).find('.slickPrev'));
    var _nextArrow = $($(ele).find('.slickNext'));
    if( _prevArrow.length > 0 && _nextArrow.length > 0 ){
      $(ele).slick('slickSetOption', 'prevArrow', _prevArrow);
      $(ele).slick('slickSetOption', 'nextArrow', _nextArrow);
      $(ele).slick('refresh');
      $(ele).addClass('customSlickArrow');
      _prevArrow.removeClass('hide');
      _nextArrow.removeClass('hide');
    }
  });*/
}

function improvedMaddleSectionSlide() {
  if (!$("[data-maddle-slider]").length) {
    return;
  }
  $("[data-maddle-slider]").not(".slick-initialized").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    cssEase: "ease",
    draggable: false,
    swipe: false,
    swipeToSlide: false,
    touchMove: false,
    dots: false,
    fade: true,
    cssEase: "ease-in-out",
    arrows: false,
  });

  //change slide when swatch is clicked
  $(document).on("click", "[data-maddle-slider] .swatch-img", function name(e) {
    e.preventDefault();
    let curentIndex = Number($(this).attr("data-index"));
    setTimeout(function () {
      $("[data-maddle-slider] .swatch-img").removeClass("active");
      $(
        '[data-maddle-slider] .swatch-img[data-index="' + curentIndex + '"]'
      ).addClass("active");
      $("[data-maddle-slider]").slick("slickGoTo", curentIndex - 1);
    }, 100);
  });
}

function cartAccessories() {
  var _cartTimeout = 1;
  var _cartRoutes = JSON.parse(
    document.querySelector("[data-cart-routes]").innerHTML
  );
  if (_cartRoutes.accessoriesOnDesktop == false && $(window).width() > 767) {
    setTimeout(function () {
      theme.sizeCartDrawerFooter();
    }, _cartTimeout + 255);
    return;
  }
  if ($("#CartDrawer.accessoriesHide").length > 0) {
    return;
  }
  var cartAccessories = JSON.parse($("#product-accessories-JSON").text());
  if (cartAccessories.length > 0) {
    if (
      $(".drawer__accessories .pro-accessories-slider .gridproductwrapper")
        .length == 0
    ) {
      var HTML = "";
      $.each(cartAccessories, function (index, cartAccessorie) {
        var featured_image = cartAccessorie.featured_image,
          availableVariant = "";
        if (featured_image.indexOf(".png") > -1) {
          featured_image = featured_image.replace(".png", "_{width}x.png");
        } else if (featured_image.indexOf(".jpg") > -1) {
          featured_image = featured_image.replace(".jpg", "_{width}x.jpg");
        } else if (featured_image.indexOf(".jpeg") > -1) {
          featured_image = featured_image.replace(".jpeg", "_{width}x.jpeg");
        }

        $.each(
          cartAccessorie.variants,
          function (index, cartAccessorieVariant) {
            if (cartAccessorieVariant.available == true) {
              availableVariant = cartAccessorieVariant;
              return false;
            }
          }
        );
        if (availableVariant == "") {
          availableVariant = cartAccessorie.variants[0];
        }
        var money_price = availableVariant.price;
        var compare_at_price = money_price - (money_price * 20) / 100;
        var priceHTML = `<span class="price--listing price--on-sale"><span class="line-through mr-0">${theme.Currency.formatMoney(
          money_price,
          theme.settings.moneyFormat
        )}</span> &#65515; <span class="text-red font-extrabold">${theme.Currency.formatMoney(
          compare_at_price,
          theme.settings.moneyFormat
        )}</span></span>`;
        /*if(availableVariant.compare_at_price != null && availableVariant.compare_at_price > availableVariant.price){ var priceHTML = `<span class="price--listing price--on-sale"><span class="line-through mr-0">${theme.Currency.formatMoney(availableVariant.compare_at_price, theme.settings.moneyFormat )}</span> &#65515; <span class="text-red font-extrabold">${ theme.Currency.formatMoney(availableVariant.price, theme.settings.moneyFormat ) }</span></span>`;
      }else{ var priceHTML = `<span class="price--listing"><span class="price-item--regular">${ theme.Currency.formatMoney(availableVariant.price, theme.settings.moneyFormat ) }</span></span>`; }*/

        var _plusSVG =
          '<svg width="15" height="15" viewBox="0 0 15 15" fill="none"><path fill="currentColor" d="M15 7.5C14.9659 5.49898 14.1605 3.59148 12.7579 2.18884C11.355 0.785975 9.46689 -4.63228e-05 7.5 2.04754e-09C5.53311 4.63269e-05 3.64472 0.7862 2.24209 2.18884C0.83922 3.59171 0.0340082 5.49907 0 7.5C0.0340992 9.50102 0.839454 11.4085 2.24209 12.8112C3.64496 14.214 5.53311 15 7.5 15C9.46689 15 11.3553 14.2138 12.7579 12.8112C14.1608 11.4083 14.966 9.50093 15 7.5ZM8.253 11.332C8.2538 11.5355 8.17476 11.7309 8.03341 11.8747C7.89195 12.0187 7.69986 12.0992 7.49991 12.0983C7.30046 12.0975 7.10964 12.016 6.96943 11.8717C6.8277 11.7291 6.74752 11.5349 6.74672 11.3319L6.75204 8.26087L3.7339 8.26629C3.53437 8.26548 3.34354 8.18389 3.20342 8.03968C3.06161 7.89701 2.98142 7.70284 2.98072 7.49991C2.97983 7.29643 3.05896 7.10099 3.2004 6.95706C3.34177 6.81322 3.53386 6.7327 3.7339 6.73353L6.75204 6.73895L6.74672 3.66793C6.74664 3.39406 6.89032 3.14107 7.12333 3.00409C7.35634 2.86729 7.64351 2.8673 7.87651 3.00409C8.10952 3.14106 8.2532 3.39407 8.25312 3.66793L8.2478 6.73895L11.2659 6.73353C11.5351 6.73344 11.7837 6.87964 11.9184 7.11674C12.0528 7.35383 12.0528 7.64603 11.9184 7.88311C11.7837 8.1202 11.5351 8.2664 11.2659 8.26631L8.2478 8.2609L8.253 11.332Z"/></svg>';

        HTML =
          HTML +
          `<div class="gridproductwrapper"><div><a class="" href="${cartAccessorie.url}" tabindex="0"><span class="visually-hidden">${cartAccessorie.title}</span></a>
<div class="w-full rounded-4xl md:rounded-2xl wrapimagerounded relative js"><div class="img-box"><img class="product--image w-full overflow-hidden h-full object-cover  absolute top-0 lazyload"
alt="${cartAccessorie.alt}"  data-src="${featured_image}" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"
data-aspectratio="${cartAccessorie.aspect_ratio}" data-sizes="auto" data-image/></div></div><div class="w-full pro-accessories-bottom">
<h4 class="pro-accessories-title" >${cartAccessorie.title}</h4>${priceHTML}
<span class="recommended-check"><input id="Checkbox-${cartAccessorie.id}" type="checkbox" class="recomnd-chekbox" data-vid="${availableVariant.id}" 
data-available="${availableVariant.available}" data-text-add="Add to cart" data-text-added="Added to cart" >
<label for="Checkbox-${cartAccessorie.id}" class="recommended-check-text">Add to cart</label>${_plusSVG}
</span></div></div></div>`;
      });
      $(".drawer__accessories .pro-accessories-slider").empty().append(HTML);
      $(
        ".drawer .pro-accessories-slider.sliderVertical_true.slick-initialized"
      ).slick("unslick");
      $('#CartContainer div[class*="_accessories"]').empty();
      var accessoriesHeight =
        $(".drawer__accessories").outerHeight() -
        $(".drawer__accessories .pro-accessories h3").outerHeight(true) -
        40;
      if ($(window).width() < 768) {
        $(".drawer .pro-accessories-slider").removeAttr("style");
      } else {
        $(".drawer__accessories .pro-accessories-slider").height(
          accessoriesHeight
        );
      }
      drawerAccessoriesSlider();
      accessoriesChecked();
    }
  }
  if ($(window).width() < 768) {
    if ($(".ajaxcart__footer_accessories").html().length == 0) {
      $(".drawer .pro-accessories-slider").removeAttr("style");
      $(".drawer__accessories .pro-accessories-slider.slick-initialized").slick(
        "unslick"
      );
      var _html = $(".drawer__accessories").html();
      $(".drawer__accessories .pro-accessories-slider").empty();
      _html = $(_html)[0];
      $(".ajaxcart__footer_accessories").empty().append(_html);
      setTimeout(function () {
        drawerAccessoriesSlider();
        slickClass();
        accessoriesChecked();
      }, 500);
      _cartTimeout = _cartTimeout + 500;
    }
  }
  setTimeout(function () {
    theme.sizeCartDrawerFooter();
  }, _cartTimeout + 255);
  return true;
}

window.addEventListener("resize", theme.Helpers.debounce(windowResize, 1000));
function windowResize() {
  cartAccessories();
  return false;
}

//Product new tampltae JS -- END

// START ----> Product tamplate [ products--SS23 ] JS
// function colorSwatchList() {
//   var proSection =
//     document.querySelector(".shopify-section.main-product") || null;
//   var proMediaBlock =
//     document.querySelector("[data-product-single-media-group]") || null;
//   var colorSwatchItems =
//     document.querySelectorAll(
//       "[data-color-swatch-list] [data-color-swatch-item]:not(.active)"
//     ) || null;
//   if (colorSwatchItems.length > 0) {
//     // console.log("colorSwatchItems",colorSwatchItems);
//     colorSwatchItems.forEach((item) => {
//       item.addEventListener("click", function (e) {
//         e.preventDefault();
//         // console.log("clicked",this);
//         var handle = this.dataset.handle;
//         //if(proSection) proSection.classList.add("loading");
//         // if(proMediaBlock) proMediaBlock.style.opacity = 0;

//         //for def-img
//         var defImg = proSection.querySelector("[data-pro-def-img]") || null;

//         // fastly add opacity 0 for slider to show fast default img
//         if (item.dataset.img != "undefined") {
//           //for def-img
//           if (defImg) {
//             defImg.style.opacity = "1";
//             defImg.setAttribute("src", `${item.dataset.img}`);
//           }

//           var sliders =
//             proSection.querySelectorAll(".main-product .slick-slider") || null;
//           if (sliders.length > 0) {
//             sliders.forEach((slider) => {
//               slider.style.opacity = "0";
//             });
//           }
//         }

//         if ($("[data-main-slider].slick-initialized").length > 0)
//           $("[data-main-slider]").slick("unslick");
//         if ($("[data-thumbnail-slider].slick-initialized").length > 0)
//           $("[data-thumbnail-slider]").slick("unslick");
//         mainProductHTML(this, handle, proSection);
//         history.pushState(
//           null,
//           null,
//           `/products/${item.dataset.onlyHandle}?variant=${item.dataset.prodid}`
//         );
//       });
//     });
//   }
// }
function colorSwatchList() {
  const colorSwatchItems = document.querySelectorAll(
    "[data-color-swatch-list] [data-color-swatch-item]:not(.active)"
  );

  if (colorSwatchItems.length > 0) {
    colorSwatchItems.forEach((item) => {
      item.addEventListener("click", function (e) {
        e.preventDefault();
        const handle = this.dataset.onlyHandle;
        const variantId = this.dataset.prodid;

        // Просто редирект на страницу товара с нужным вариантом
        window.location.href = `/products/${handle}?variant=${variantId}`;
      });
    });
  }
}
window.addEventListener("load", () => {
  var colorSwatchItems = document.querySelector(".color-item.active") || null;
  history.pushState(
    null,
    null,
    `/products/${colorSwatchItems.dataset.onlyHandle}?variant=${colorSwatchItems.dataset.prodid}`
  );
});
colorSwatchList();

//magae review widget
var stampedRev =
  document.querySelector("[data-custom-stamped-reviews]") || null;
if (stampedRev) {
  var t_out = 5000;
  manage_reviewsWidget(stampedRev, t_out);
}

function mainProductHTML(item, handle, proSection) {
  const origin = window.location.origin;
  const mainProId = item.dataset.sectionId.replace("shopify-section-", "");

  // Если есть accessories-секция
  const proAcc = document.querySelector(".pdp-pro-perf-acces") || null;
  let fetchURL;

  if (proAcc) {
    const proAccId = proAcc.getAttribute("id").replace("shopify-section-", "");
    fetchURL = `${origin}/?sections=${mainProId},${proAccId}&product_handle=${handle}`;
  } else {
    fetchURL = `${origin}/?sections=${mainProId}&product_handle=${handle}`;
  }

  fetch(fetchURL)
    .then((response) => response.json())
    .then((htmlObj) => {
      const parser = new DOMParser();
      const parsedHtml = parser.parseFromString(
        htmlObj[mainProId],
        "text/html"
      );

      // Обновляем sticky title, если есть
      const stickyTitleEl = document.querySelector(".stikey-add-to-cart h6");
      const newStickyTitleEl = parsedHtml.querySelector(
        ".stikey-add-to-cart h6"
      );
      if (stickyTitleEl && newStickyTitleEl) {
        stickyTitleEl.innerHTML = newStickyTitleEl.innerHTML;
      }

      mainPro_replaceHTML(item, proSection, parsedHtml);

      // Обновляем accessories-секцию, если есть
      if (proAcc) {
        const proAccId = proAcc
          .getAttribute("id")
          .replace("shopify-section-", "");
        const parsedAccHtml = parser.parseFromString(
          htmlObj[proAccId],
          "text/html"
        );
        const newAccSection = parsedAccHtml.querySelector(
          `#shopify-section-${proAccId}`
        );
        const currentAccSection = document.querySelector(
          `#shopify-section-${proAccId}`
        );

        if (newAccSection && currentAccSection) {
          currentAccSection.innerHTML = newAccSection.innerHTML;
        }
      }
    })
    .catch((error) => {
      console.error("Product section load error:", error);
    });
}

function mainPro_replaceHTML(item, proSection, parsedHtml) {
  var section = document.querySelector("#" + item.dataset.sectionId) || null;
  // console.log("section",section);
  if (section) {
    //for bg color
    var bgColor = item.dataset.bgColor || null;
    if (bgColor) {
      section.style.background = bgColor;
    }

    var renderedSection =
      parsedHtml.querySelector("#" + item.dataset.sectionId) || null;
    if (renderedSection) {
      // console.log("renderedSection",renderedSection);
      var videoWise = section.querySelector("[data-videowise-tab]") || null;
      section.querySelector(".product-template__container").innerHTML =
        renderedSection.querySelector(".product-template__container").innerHTML;

      //for reviews
      // StampedFn.reloadUGC();
      var stampedRev =
        document.querySelector("[data-custom-stamped-reviews]") || null;
      if (stampedRev) {
        StampedFn.reloadUGC();
        var t_out = 1000;
        manage_reviewsWidget(stampedRev, t_out);
      }

      if (videoWise) {
        if (videoWise.classList.contains("hide")) {
          section.querySelector("[data-videowise-tab]").classList.add("hide");
        } else {
          section
            .querySelector("[data-videowise-tab]")
            .classList.remove("hide");
        }
        // videowise custom js
        var videowiseDiv = document.createElement("div");
        var widgetId = videoWise.querySelector(".reeview-app-widget");
        if (widgetId) {
          // console.log("widgetId",videoWise);
          videowiseDiv.id = widgetId.getAttribute("id");
          videowiseDiv.className = "reeview-app-widget";
          // console.log("VW",section.querySelector('[data-videowise-tab]'));
          var forRemove = section.querySelector("[data-videowise-tab]");
          if (forRemove) {
            forRemove.querySelector(".reeview-app-widget").remove();
            // console.log("VW",section.querySelector('[data-videowise-tab]'));
            section
              .querySelector("[data-videowise-tab]")
              .appendChild(videowiseDiv);
            waitForVideowise(() => {
              window.initVideowise();
            });
            // section.querySelector("[data-videowise-tab]").innerHTML = videoWise.innerHTML ;
          }
        }
      }

      mainPro_reInitAllSliders(); // reInit all sliders [ main slider, thumbnail slider ]

      mainPro_reInitMediaVideos(); // reInit videos in main slider

      productShips(); // reInit shipping timer - [ snippets/pdp-shipping-and-countdown.liquid ]

      colorSwatchList(); // reInit click event of color swatch
      accordion("Accordion"); // reInit accordion click event
      ajaxCart.init(); // this is for ADD_TO_CART button
    }
  }

  // setTimeout(function(){
  //   if(proSection) proSection.classList.remove("loading");
  // },500);
}
function waitForVideowise(callback, triesLeft = 10) {
  if (typeof window.initVideowise === "function") {
    callback();
  } else if (triesLeft > 0) {
    setTimeout(() => waitForVideowise(callback, triesLeft - 1), 300);
  } else {
    console.warn("initVideowise не найден после 10 попыток");
  }
}
function mainPro_reInitAllSliders() {
  // mainSlider();
  setTimeout(function () {
    // $("[data-thumbnail-slider]").slick("reinit");
    mainSlider();
  }, 300);
  // $('.pro-accessories-slider.slick-initialized').slick('unslick');
  // setTimeout(function(){
  //   proAccessoriesSlider();
  // },500);
}

function mainPro_reInitMediaVideos(time_O = 500) {
  setTimeout(function () {
    $("*[data-product-media-type-video]").each(function (index, el) {
      var sectionId = $(this)
        .closest("[data-section-id]")
        .attr("data-section-id");
      // console.log("ProductVideo.init",sectionId);
      theme.ProductVideo.init(el, sectionId);
    });
  }, time_O);
}

function manage_reviewsWidget(stampedRev, t_out) {
  setTimeout(function () {
    var revWidget = document.querySelector(".pdp-product-reviews") || null;
    if (revWidget) {
      if (stampedRev.innerText == "") {
        revWidget.classList.add("hide");
      } else {
        revWidget.classList.remove("hide");
      }
    }
  }, t_out);
}

// for VIDEOWISE video SECTION / BLOCK [ HIDE -- SHOW ]
var videoWiseWidget = document.querySelector("[data-videowise-widget]") || null;
var videoWiseVideo = document.querySelector("[data-videowise-video]") || null;
window.addEventListener("load", (event) => {
  // console.log("page is fully loaded");
  // console.log("videoWiseVideo",videoWiseVideo);
  if (videoWiseVideo && videoWiseVideo.innerHTML != "") {
    videoWiseVideo.closest("[data-videowise-tab]").classList.remove("hide");
  }

  setTimeout(function () {
    // console.log("videoWiseWidget",videoWiseWidget);
    if (videoWiseWidget && videoWiseWidget.innerHTML == "") {
      videoWiseWidget.closest(".shopify-section").classList.add("hide");
    }
  }, 1000);
});

// END ----> Product tamplate [ products--SS23 ] JS

// This will only render in the theme editor
if (Shopify.designMode) {
  document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("shopify:section:load", function () {
      const improvedMaddleSection =
        event.target.closest(".new-improved-section") || null;
      if (improvedMaddleSection) {
        improvedMaddleSectionSlide();
      }
    });
  });
}
